import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { CrossSolidIcon } from '@compono/ui-icons';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../../hooks/useTheme.js';
import { IconButton } from '../../IconButton/IconButton.js';

var AlertCloseButton = forwardRef(function AlertCloseButton(props, ref) {
    var children = props.children, restProps = __rest(props, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(restProps, {
        themeKey: "alertCloseButton",
    });
    return (jsx(IconButton, __assign({ ref: ref, size: "sm", tone: "secondary", look: "naked", label: "Close alert", rounded: true, type: "button" }, forwardProps, { children: children || jsx(CrossSolidIcon, {}) })));
});
AlertCloseButton.displayName = "AlertButton";

export { AlertCloseButton };
//# sourceMappingURL=AlertCloseButton.js.map
